import { useState } from 'react';

/**
 * "I want $3 of this" — a product priced in ZWG still gets thought about in USD by a lot of
 * people, so this turns a USD figure (whole or fractional — 3, 0.5, 2.25) into the ZWG amount
 * the form actually submits, using the platform's admin-configurable exchange rate.
 */
export function UsdCalculator({ rate, currency, onApply }: {
  // Jackson serialises the backend's BigDecimal as a JSON number, not a string.
  rate: number | null | undefined;
  currency: string | null | undefined;
  onApply: (zwgAmount: string) => void;
}) {
  const [usd, setUsd] = useState('');

  if (currency !== 'ZWG' || !rate) return null;

  const usdNum = Number(usd);
  const valid = usd.trim() !== '' && Number.isFinite(usdNum) && usdNum > 0;
  const zwg = valid ? (usdNum * rate).toFixed(2) : null;

  return (
    <div className="mt-2 flex items-center gap-2 rounded-lg border border-dashed border-ink-300 bg-ink-50 px-3 py-2">
      <span className="shrink-0 text-xs font-medium text-ink-500">USD amount</span>
      <input
        className="input h-9 flex-1 text-sm tabular"
        inputMode="decimal"
        value={usd}
        placeholder="e.g. 3 or 0.5"
        onChange={(e) => setUsd(e.target.value)}
      />
      <button
        type="button"
        className="btn-secondary h-9 shrink-0 whitespace-nowrap text-xs"
        disabled={!zwg}
        onClick={() => zwg && onApply(zwg)}
      >
        {zwg ? `Use ZWG ${zwg}` : 'Use'}
      </button>
    </div>
  );
}
